import { ReturnRequestLineItemCustomerImageDto } from "@babackapp/private-api-client/types";
import Viewer from "react-viewer";

type ArticleItemCustomerImageViewerProps = {
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  images: ReturnRequestLineItemCustomerImageDto[];
};

export default function ArticleItemCustomerImageViewer({
  currentIndex,
  setCurrentIndex,
  images,
}: ArticleItemCustomerImageViewerProps) {
  const open = currentIndex !== -1;
  const onClose = () => setCurrentIndex(-1);

  return (
    <Viewer
      visible={open}
      onClose={onClose}
      activeIndex={currentIndex}
      images={images.map((photo) => ({
        src: photo.imageUrl,
        alt: photo.imageId,
      }))}
      downloadInNewWindow={true}
      loop={true}
    />
  );
}
